var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('ImportMasterPayments')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }